import { Col, Image, Title, Text, Grid, Stepper, Container, Center, Button, Group } from '@mantine/core';
import { Minus, Flame, InfoCircle, RowInsertBottom } from 'tabler-icons-react';
import { NavLink } from 'react-router-dom';
import { UALContext } from 'ual-reactjs-renderer';
import { Asset } from '@greymass/eosio';

import Withdraw from '../../lib/Withdraw'
import { AAMiddleware, IBalances } from '../../store/AAMiddleware';
import { useContext, useEffect, useState } from 'react';
import { Balances } from '../../pages/nftbacker/User/Main/Balances/Balances';
import BackedTokenAmount from './BackedTokenAmount';

const api = new AAMiddleware()

export default function UnclaimedBalanceNotification({balances}) {
    const ual = useContext(UALContext) as any;

    const onWithdraw = async () => {
        if ( ! balances.length ) { return }
        const assets = balances.map((b)=>{
            return Asset.from(`${b.amount} ${b.token_symbol}`)
        })
        Withdraw(assets,ual)
    }

    return (
        <>
            <Image height={400} src='/images/digital_trading_card-16x9.jpg' />
            <Center>
            <Container mx='xl' my='xl'>
                <Title align='center' mb='xl' order={2}>You Have a Balance to Claim!</Title>

                <Center mb='xl'>
                {
                    balances?.map((t) => <BackedTokenAmount key={t.token_symbol} backed_token={t} />)
                }
                </Center>
    
                <Text align='center' size='lg'>
                    It seems you burned a backed NFT on another site and didn't withdraw the balance.
                </Text>
                <Text align='center' size='lg'>
                    When burning a backed NFT, do it here on NFT Backers and we can save you an extra step.
                </Text>
                <Grid my='xl'>
                    <Grid.Col sm={12} md={6}>
                        <Title align='center' mb='lg' order={3}>On NFT Backers</Title>
                        <Stepper active={0} breakpoint="xs">
                            <Stepper.Step icon={<Flame />} label="Burn & Withdraw" description="SINGLE STEP!" allowStepSelect={true}>
                            </Stepper.Step>
                        </Stepper>
                        <Text size='sm' mt='lg'>
                                    When you burn your NFT here on NFT Backers, we immediately send any redeemed assets to your wallet.
                                    You don't worry about the hassle of withdrawing assets - we take care of it for you!
                        </Text>
                    </Grid.Col>
                    <Grid.Col sm={12} md={6}>
                        <Title align='center' mb='lg' order={3}>Other Platforms</Title>
                        <Stepper active={0} breakpoint="xs">
                            <Stepper.Step icon={<Flame />} label="Burn" description="" allowStepSelect={true}>
                            </Stepper.Step>
                            <Stepper.Step icon={<Minus />} color='red' label="Withdraw" description="" allowStepSelect={false}>
                            </Stepper.Step>
                        </Stepper>
                        <Text size='sm' mt='lg'>
                                    When you burn your NFT on other platforms, any assets released are held in your name on the NFT Backers contract, awaiting your withdrawal.
                                    You must then visit NFT Backers to claim those assets.
                        </Text>
                    </Grid.Col>
                </Grid>
                <Text mb='xl' align='center' size='md'>Click the button below to claim your assets.</Text>
                {
                    balances ? (
                        <Group mb='xl' position='center'>
                            <Button onClick={onWithdraw} size='xl'>Withdraw</Button>
                        </Group>
                    ) : <></>
                }
            </Container>
            </Center>

        </>
    );
}

/*
    <Alert icon={<InfoCircle size={16} />} title="You have an unclaimed balance" color="grape" withCloseButton>
      It seems you burned a backed NFT and didn't claim the balances. Remember, if you burn an NFT here 
      on NFT Backers, we can save you this extra step. <NavLink to="/about/burning">Learn more.</NavLink>
    </Alert>

*/